module.exports = __webpack_public_path__ + "img/jl-servce-icon_2.519dd568.png";